<template>
  <div class="card mb-25 border-0 radius-7 bg-white number-of-tickets-box">
    <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing heigth-chart-realtime">
      <div class="d-sm-flex align-items-center justify-content-between">
        <h6 class="card-title fw-bold mb-0">Gravações por tempo</h6>
      </div>
      <div id="numberOfTicketsChart" class="chart">
        <apexchart
          type="bar"
          height="251"
          :options="numberOfTicketsChart"
          :series="[{name: 'Quantidade', data: Object.values(getTimers)}]"
        ></apexchart>
      </div>
      <div class="mt-40">
        <div class="col-12 mt-20">
          Este gráfico representa a quantidade de gravações com base na duração de cada uma, elas estão agrupadas nos valores descritos acima.
        </div>
      </div>
      <!-- <ul class="info ps-0 mb-0 list-unstyled text-center">
        <li class="d-inline-block">
          <div class="d-flex align-items-end mb-4 position-items-qtd">
            <h4 class="mb-0 text-success lh-1 fw-black">{{ getTimers["0_5"] }}</h4>
          </div>
          <span class="fw-medium fs-12 text-black-emphasis text-uppercase">
            0 - 5 MINUTOS
          </span>
        </li>
        <li class="d-inline-block">
          <div class="d-flex align-items-end mb-4 position-items-qtd">
            <h4 class="mb-0 text-info-light lh-1 fw-black">{{ getTimers["5_10"] }}</h4>
          </div>
          <span class="fw-medium fs-12 text-black-emphasis text-uppercase">
            5 - 10 MINUTOS
          </span>
        </li>
        <li class="d-inline-block">
          <div class="d-flex align-items-end mb-4 position-items-qtd">
            <h4 class="mb-0 text-warning lh-1 fw-black">{{ getTimers["10_15"] }}</h4>
          </div>
          <span class="fw-medium fs-12 text-black-emphasis text-uppercase">
            10 - 15 MINUTOS
          </span>
        </li>
        <li class="d-inline-block">
          <div class="d-flex align-items-end mb-4 position-items-qtd">
            <h4 class="mb-0 text-primary lh-1 fw-black">{{ getTimers["15_20"] }}</h4>
          </div>
          <span class="fw-medium fs-12 text-black-emphasis text-uppercase">
            15 - 20 MINUTOS
          </span>
        </li>
        <li class="d-inline-block">
          <div class="d-flex align-items-end mb-4 position-items-qtd">
            <h4 class="mb-0 text-success lh-1 fw-black">{{ getTimers["bigger"] }}</h4>
          </div>
          <span class="fw-medium fs-12 text-black-emphasis text-uppercase">
            MAIS DE 20 MINUTOS
          </span>
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "RealtimeUploadTimers",

  data: function () {
    return {
      numberOfTicketsChart: {
        chart: {
          type: "bar",
          height: 251,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 3,
            horizontal: false,
            columnWidth: "42%",
            endingShape: "rounded",
            borderRadiusApplication: "end",
            distributed: true
          },
        },
        colors: ["#159269", "#20C7D9", "#C57B0A", "#1D6FF2", "#102B4D"],
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 4,
          show: true,
          colors: ["transparent"],
        },
        yaxis: {
          show: true,
          tickAmount: 5,
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: ["#607089"],
              fontSize: "14px",
              fontWeight: 500,
            },
            formatter: function (val) {
              return Math.floor(val);
            }
          },
          axisBorder: {
            show: true,
            color: "#eeeeee",
          },
        },
        xaxis: {
          categories: [
            "0 a 5 Minutos",
            "5 a 10 Minutos",
            "10 a 15 Minutos",
            "15 a 20 Minutos",
            "20+"
          ],
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: ["#159269", "#20C7D9", "#C57B0A", "#1D6FF2", "#102B4D"],
              fontSize: "14px",
              fontWeight: 500,
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        legend: {
          show: false,
          fontWeight: 500,
          fontSize: "14px",
          position: "bottom",
          horizontalAlign: "center",
          fontFamily: "Red Hat Display, sans-serif",
          labels: {
            colors: "#607089",
          },
          markers: {
            offsetX: -2,
          },
          itemMargin: {
            horizontal: 8,
            vertical: 5,
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
          y: {
            formatter: function (val) {
              return Math.floor(val);
            }
          }
        },
        grid: {
          show: true,
          strokeDashArray: 5,
          borderColor: "#dfe7f1",
        },
      },
    };
  },
  computed:{
    ...mapGetters([
      'getTimers'
    ])
  },
});
</script>

<style>
.d-inline-block{
  margin-left: 10px !important;
  margin-right: 10px !important;
}

.position-items-qtd{
  justify-content: center !important;
}

.fs-12{
  font-size: 11px !important;
}
</style>
